import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../@core/services/master.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NotificationService } from '../../@core/services/notification.service';
import { NbToastrService } from '@nebular/theme';
import { stringify } from 'querystring';
import { MenuService } from '../pages-menu';
declare var $: any;

@Component({
  selector: 'ngx-dashboard-manager',
  templateUrl: './dashboard-manager.component.html',
  styleUrls: ['./dashboard-manager.component.scss']
})
export class DashboardManagerComponent implements OnInit {
  form: FormGroup;
  projectForm: FormGroup;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginateData: any;
  firstItemIndex: number = 1;
  lastItemIndex: number = 0;
  tableDataLength: number = 0;
  paginationData: any;
  searchInput: any = '';
  // selectedCustomerName: any = "";
  selectedEngineer: any = "";
  selectedCurrentStage: any = "";
  selectedRfqDate: any = "";
  fromRfqDate: any = '';
  toRfqDate: any = '';
  showModalECD: boolean = false; // ECD modal visibility flag
  showModalRFQ: boolean = false; // RFQ modal visibility flag
paginatestartIndex:number = 0
  paginateendIndex:number = 10
  fromExpectedCompletionDate: any = '';
  toExpectedCompletionDate: any = '';
  selectedExpetedCompletionDate: any = "";
  matchedCustomerData: any[] = []; // To store the matching result
  matchedProjectData: any[] = []; // To store the matching result
  modalRef: NgbModalRef | null = null;
  selectedCustomerName: string = '';
  selectedProjectName: string = '';
  searchText: string = '';
  showAddCustomerButton: boolean = false;
  allCustomerData = [];
  isProjectNameDuplicate: boolean = false;
  isRefresh: boolean = false;
  selectedVersionId: any = null;
  showDutyInput: boolean = false;
  showProjectDropdown: boolean = false;
  filteredProjectNames: string[] = [];
  // onQn123: any = {
  //   q1: false, q2: false, q3: false,
  // }
  // allCustomerData = [
  //   {
  //     serialNumber: 100001,
  //     customerName: "John Doe",
  //     city: "New York",
  //     state: "NY",
  //     country: "USA",
  //     gstNumber: "GST12345",
  //     createdBy: "Admin",
  //     createdOn: "2024-10-01",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-11-01",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100002,
  //     customerName: "Jane Smith",
  //     city: "Los Angeles",
  //     state: "CA",
  //     country: "USA",
  //     gstNumber: "GST67890",
  //     createdBy: "Manager",
  //     createdOn: "2024-09-15",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-10-20",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100003,
  //     customerName: "Michael Johnson",
  //     city: "Chicago",
  //     state: "IL",
  //     country: "USA",
  //     gstNumber: "GST24680",
  //     createdBy: "Staff",
  //     createdOn: "2024-08-10",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-09-05",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100004,
  //     customerName: "Emily Davis",
  //     city: "Houston",
  //     state: "TX",
  //     country: "USA",
  //     gstNumber: "GST13579",
  //     createdBy: "Admin",
  //     createdOn: "2024-07-20",
  //     lastModifiedBy: "Manager",
  //     lastModifiedOn: "2024-09-25",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100005,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100006,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: false,
  //   },
  // ];
  engineersData = [];
  thisMonthProjects: any[] = [];
  // allCustomerData = [
  //   {
  //     serialNumber: 1,
  //     projectName: "Project Alpha",
  //     customerName: "Customer A",
  //     rfqDate: new Date("2024-01-15"),
  //     assignedTo: "John Doe",
  //     assignedDate: new Date("2024-01-20"),
  //     expetedCompletionDate: new Date("2024-02-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "50",
  //     status: "In Progress",
  //     currentStage: "procurement",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 2,
  //     projectName: "Project Beta",
  //     customerName: "Customer B",
  //     rfqDate: new Date("2024-02-01"),
  //     assignedTo: "Jane Smith",
  //     assignedDate: new Date("2024-02-05"),
  //     expetedCompletionDate: new Date("2024-03-01"),
  //     targetLeadTime: "3 weeks",
  //     ageing: "1 week",
  //     progress: "30",
  //     status: "In Progress",
  //     currentStage: "Costing",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 3,
  //     projectName: "Project Gamma",
  //     customerName: "Customer C",
  //     rfqDate: new Date("2024-01-10"),
  //     assignedTo: "Alice Johnson",
  //     assignedDate: new Date("2024-01-12"),
  //     expetedCompletionDate: new Date("2024-02-10"),
  //     targetLeadTime: "6 weeks",
  //     ageing: "4 weeks",
  //     progress: "70",
  //     status: "On Hold",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 4,
  //     projectName: "Project Delta",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-01-25"),
  //     assignedTo: "Bob Williams",
  //     assignedDate: new Date("2024-01-30"),
  //     expetedCompletionDate: new Date("2024-03-05"),
  //     targetLeadTime: "5 weeks",
  //     ageing: "3 weeks",
  //     progress: "20",
  //     status: "Delayed",
  //     currentStage: "procurement",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 5,
  //     projectName: "Project Epsilon",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "90",
  //     status: "Not Started",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 6,
  //     projectName: "Project E",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "20%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 7,
  //     projectName: "Project M",
  //     customerName: "Customer M",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-04-15"),
  //     expetedCompletionDate: new Date("2024-06-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "30%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 8,
  //     projectName: "Project M",
  //     customerName: "Customer OR",
  //     rfqDate: new Date("2024-08-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-12-15"),
  //     targetLeadTime: "12 weeks",
  //     ageing: "1 weeks",
  //     progress: "40%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   }
  // ];


  // pageSize: number;
  addtionalChargesDetails = [];
  downloadData = [];
  closeResult: string;
  isSaving: any;
  customerForm: any;
  allCustomerDetails = [];
  userId: number;
  role: any;
  selectedCustomerId: any;
  currentDate: any;
  assignDate: any;
  projectsData: any;
  editingRowId: number | null = null;
  openStatusCount: number;
  overdueCount: number;


  changedstage: any;
  allProjectDetails = [];
  selectedProjectId: any;
  isCustomerNameDuplicate: boolean = false;
  selectedAssigned_to_id: any;
  // selectedCurrentstage: any;
  selectedmatchedCustomerData: any;
  projectNameDetails: any[];
  allOpenProjectDetails: any;
  groupedProjectData: any[] = [];
  currentPageIndex: number = 0;

  rowsPerPage: number | string = 10;

  paginatedData: any[] = [];
  // rowsPerPage = 10; 
  pageSizeOptions: (number | string)[] = [10, 20, 50, 'All'];

  maxToday: string = '';

  nextMaxDate: string = '';
  isExpectedCompletionDateDisabled: boolean = true;
  onQn123:any = {
    q1: null,  // Landing cost
    q2: null,  // Duties
    q3: null   // Duty Value
  };

  dutyValuePercentage: number = 0;





  constructor(private f_builder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private menuService: MenuService,
    private datePipe: DatePipe,
    private notify: NbToastrService,
    private cdRef: ChangeDetectorRef
  ) {

    const now = new Date();
    // this.currentDate = now.toISOString(); 
    this.currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.assignDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');


  }


  ngOnInit(): void {
    this.role = ''
    this.userId = Number(sessionStorage.getItem('user_id'));
    this.role = sessionStorage.getItem('role');

    this.projectForm = this.f_builder.group({
      newProjectName: ['', Validators.required],
      projectNo: ['', ],
      description: ['', ],
      customerFullName: ['', Validators.required],
      rfqDate: ['', Validators.required],
      completionDate: ['', Validators.required],
      targetLT: ['', Validators.required],
      assignTo: ['', Validators.required],
      currentStage: ['', Validators.required],
      version_id: [{ value: 1, disable: true }, Validators.required]
    });

    this.customerForm = this.f_builder.group({
      _customerFullName: ['', [Validators.required, Validators.minLength(2)]],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      gstNumber: ['', [Validators.required]], // Example GST validation
    });

    this.getAllcustomers();
    this.getdata();
    this.getAllProjectData();
    const currentDate = new Date();
    //  this.maxToday = currentDate.toISOString().split('T')[0];    
    const istDate = new Date(currentDate.getTime() + (5.5 * 60 * 60 * 1000));
    this.maxToday = istDate.toISOString().split('T')[0];
    const nextDay = new Date(istDate); nextDay.setUTCDate(nextDay.getUTCDate() + 1);
    this.nextMaxDate = nextDay.toISOString().split('T')[0];
    //  this.nextMaxDate = this.maxToday ;
    this.projectForm.get('currentStage')?.valueChanges.subscribe(newStage => {
  if (this.previousStage === 'Costing' && newStage === 'Procurement') {
    console.log("Stage changed: Costing → Procurement");
    
    // DO NOT RESET Landing Cost values
    this.keepLandingCostValues();
  }
});


  }

  receiveData(){
  let receiveData:any = history.state
    console.log('receiveData => ', receiveData, receiveData?.currentPage)
    if(receiveData){
      if(receiveData.hasOwnProperty('rowsPerPage')){
      this.rowsPerPage = !!receiveData ?  receiveData.rowsPerPage : 10
      }
      if(receiveData.hasOwnProperty('currentPage')){
      this.currentPage = !!receiveData ?  receiveData.currentPage : 1
       this.paginate();
      }

    }
    history.replaceState({}, '')
}
  today: Date = new Date();
  isECDGreaterThanToday(dateString: string | Date): boolean {
  if (!dateString) return false;
  const today = new Date();
  const ecdDate = new Date(dateString);
  return ecdDate < today;
}
keepLandingCostValues() {
  // Keep values AS IS – don't modify them
  console.log("Keeping previous Landing Cost values:", this.onQn123, this.dutyValuePercentage);
}



  calculateAgeing(assignedDate: string, status: string, closedDate?: string): number {
    const assignedDateObj = new Date(assignedDate);
    let endDate = new Date();

    if (status === 'Closed' && closedDate) {
      endDate = new Date(closedDate);
    }

    const timeDifference = endDate.getTime() - assignedDateObj.getTime();
    return Math.floor(timeDifference / (1000 * 3600 * 24));
  }

  filterProjectNames() {
    const input = this.selectedProjectName.toLowerCase();
    this.filteredProjectNames = this.projectNameDetails.filter(name =>
      name.toLowerCase().includes(input)
    );
  }

  selectProjectName(name: string) {
    this.selectedProjectName = name;
    this.showProjectDropdown = false;
    this.onSelectProject();
  }

  hideDropdown() {

    setTimeout(() => {
      this.showProjectDropdown = false;
    }, 200);
  }

  updateCardCounts(): void {
    const today = new Date();

    this.openStatusCount = this.groupedProjectData.filter(item => item.status === 'Open').length;

    this.overdueCount = this.groupedProjectData.filter(item => {
      const expectedDate = new Date(item.expectedCompletionDate);
      return expectedDate < today && item.status === 'Open';
    }).length;


    this.thisMonthProjects = this.groupedProjectData.filter(item => {
      const expectedDate = new Date(item.expectedCompletionDate);
      return expectedDate.getMonth() === today.getMonth() &&
        expectedDate.getFullYear() === today.getFullYear();
    });
  }

  updateRfqDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (startDate) {
      let nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.nextMaxDate = nextDay.toISOString().split('T')[0];
      this.isExpectedCompletionDateDisabled = false;
      this.projectForm.get('completionDate')?.enable();
    }
    else {
      this.isExpectedCompletionDateDisabled = true;
      this.projectForm.get('completionDate')?.disable();
    }

  }
  updatecompletionDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (startDate) {

    }
    else {
      this.projectForm.get('completionDate')?.setValue('');
      this.notify.danger('Please Select the RFQ date Before choosing an Expected Completion Date');

    }
  }

  refreshPage() {
    this.resetFields()
    this.getAllcustomers();
    // this.getAllProjects(); 
    this.getdata();
    this.getAllProjectData();
  }
  getdata() {

    let manager_id = {
      'manager_id': Number(this.userId),
    }
    this.masterService.get_manager_and_engineers(manager_id).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        let data = result;
        this.engineersData = data.engineers;
        console.log('engineersData', this.engineersData);
        ;
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    })
  }
  getAllcustomers() {

    let cus = {
      "operation_type": "READALL"
    }
    this.masterService.all_customers(cus).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        this.allCustomerDetails = result;
        console.log('allCustomerDetails', this.allCustomerDetails);
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve Customer data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the Customer data. Please try again.');
      }
    })
  }


  // Update table rows per page
  updateTableRows() {
    // this.currentPage = 1; // Reset to page 1 on dropdown change
    // this.paginate();
       this.currentPage = 1; // Reset to first page
      console.log('reset current page to 1 => ', this.currentPage)
      this.paginate();  
      this.receiveData();
  }

  paginate() {
    const data = this.groupedProjectData;
    const rows = this.rowsPerPage === 'All' ? data.length : Number(this.rowsPerPage);

    const start = (this.currentPage - 1) * rows;
    const end = this.rowsPerPage === 'All' ? data.length : start + rows;

    this.paginatedData = data.slice(start, end);
  }


  previousPage() {
    if (this.rowsPerPage === 'All') return;

    if (this.currentPage > 1) {
      this.currentPage--;
      this.paginate();
    }
  }

  nextPage() {
    if (this.rowsPerPage === 'All') return;

    const rows = Number(this.rowsPerPage);
    const maxPage = Math.ceil(this.groupedProjectData.length / rows);

    if (this.currentPage < maxPage) {
      this.currentPage++;
      this.paginate();
    }
  }


  get startIndex(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return (this.currentPage - 1) * rows + 1;
  }

  get endIndex(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return Math.min(this.currentPage * rows, this.groupedProjectData.length);
  }

  get totalPages(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return Math.ceil(this.groupedProjectData.length / rows);
  }
  originalGroupedData: any[] = [];


  // onOpenClickedProject(status: string) {
  //   console.log('openStatusCount', this.openStatusCount, status)
  //   console.log('this.matchedCustomerData', this.matchedCustomerData);
  //   this.paginatedData = structuredClone(this.groupedProjectData)


  //   this.groupedProjectData = this.paginatedData.slice(0, this.openStatusCount)

  //   this.paginatedData = this.groupedProjectData.filter(customer => customer.status === status);

  //   console.log('Matched Customer Data:', this.paginatedData);
  //   this.updateTableRows();


  // }


  // onOverdueClick() {
  //   const overdueProjects = this.getOverdueItems(this.groupedProjectData);  // use grouped data
  //   this.groupedProjectData = [...overdueProjects];  // display these in table
  //   this.overdueCount = overdueProjects.length; // update count if needed
  //   this.updateTableRows();

  //   console.log('Filtered Overdue Projects:', overdueProjects);
  // }

 onOpenClickedProject(status: string) {

  console.log(" Open Projects Clicked With Status:", status);

  // Always start from full data
  const data = structuredClone(this.originalGroupedData);
  console.log(" Original Grouped Data (Master Copy):", data);

  this.paginatedData = data.filter(item =>
    item.selectedVersionData?.status === status ||
    item.selectedVersionData?.status === 'In Progress'
  );

  console.log(" Filtered Paginated Data (Open/In Progress):", this.paginatedData);

  this.groupedProjectData = [...this.paginatedData];
  console.log(" Updated groupedProjectData for Table:", this.groupedProjectData);

  this.updateTableRows();
  console.log(" Table Rows Updated");
}

onOverdueClick() {
  const data = structuredClone(this.originalGroupedData);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  this.groupedProjectData = data.filter(item => {
    const expectedDate = new Date(item.selectedVersionData?.expectedCompletionDate);
    expectedDate.setHours(0, 0, 0, 0);
    return expectedDate < today && item.selectedVersionData?.status === 'Open';
  });

  this.updateTableRows();
}
onThisMonthClick() {

  const data = structuredClone(this.originalGroupedData);

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  this.groupedProjectData = data.filter(item => {
    const dt = new Date(item.selectedVersionData?.rfqDate);
    return dt.getMonth() === currentMonth && dt.getFullYear() === currentYear;
  });

  this.updateTableRows();
}

  getOverdueItems(data: any[]) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return data.filter(item => {
      const expectedDate = new Date(item.selectedVersionData?.expectedCompletionDate);
      expectedDate.setHours(0, 0, 0, 0);
      return expectedDate < today && item.selectedVersionData?.status === 'Open';
    });
  }


  // onThisMonthClick() {
  //   this.getThisMonthProjects(); // Populate thisMonthProjects
  //   this.groupedProjectData = [...this.thisMonthProjects]; // Update table rows
  //   this.updateTableRows();
  // }


  // onSearch(value: any) {

  //   this.searchText = value.target.value;
  //   // this.searchText = this.selectedCustomerName;
  //   const isCustomerExists = this.allCustomerData.some(
  //     (customer:any) => customer.customer_name.toLowerCase() === this.searchText.toLowerCase()
  //   );
  //   this.showAddCustomerButton = this.searchText.trim() !== '' && !isCustomerExists;
  // }
  // onProjectSearch(value: any) {

  //   this.searchText = value.target.value;
  //   // this.searchText = this.selectedCustomerName;
  //   const isProjectExists = this.allProjectDetails.some(
  //     (project:any) => project.projectName.toLowerCase() === this.searchText.toLowerCase()
  //   );
  //   // this.showAddCustomerButton = this.searchText.trim() !== '' && !isProjectExists;
  // }

  onSearch(value: any) {
  this.searchText = value.target.value;

  const isCustomerExists = this.allCustomerData.some(
    (customer: any) => customer.customer_name.toLowerCase() === this.searchText.toLowerCase()
  );

  // Show the 'Add' button only if there's text and customer doesn't exist
  this.showAddButton = this.searchText.trim() !== '' && !isCustomerExists;
}

onProjectSearch(value: any) {
  this.searchText = value.target.value;

  const isProjectExists = this.allProjectDetails.some(
    (project: any) => project.projectName.toLowerCase() === this.searchText.toLowerCase()
  );

  // You can similarly set a flag for project add button if needed
  // this.showAddProjectButton = this.searchText.trim() !== '' && !isProjectExists;
}

  onSelectProject() {


    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => cus.projectName === this.selectedProjectName)
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_to_name: cus.assigned_to_name,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    console.log('Matched Customer Data:', this.matchedCustomerData);
    this.groupProjectsByVersion(this.matchedCustomerData);
    this.updateTableRows();
    this.applyAllFilters();
    this.updateCardCounts();
  }

  onSelectCustomer() {


    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => cus.customer_name === this.selectedCustomerName)
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_to_name: cus.assigned_to_name,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    console.log('matched CustomerData', this.matchedCustomerData)
    this.groupProjectsByVersion(this.matchedCustomerData);
    this.updateTableRows();
    this.applyAllFilters();
    this.updateCardCounts();
  }

  addNewCustomer() {

    if (this.searchText) {
      let customerModal = "customerModal"
      this.openCustomerModel(customerModal);

    }
  }
  onSelectEnginner() {


    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => Number(cus.assigned_to_id) === Number(this.selectedEngineer))
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_to_name: cus.assigned_to_name,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    this.groupProjectsByVersion(this.matchedCustomerData);
    this.updateTableRows();
    this.applyAllFilters();
    this.updateCardCounts();
  }
  onSelectStage(eve: any) {


    let selectedStage = eve.target.value
    console.log('val', selectedStage);

    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => cus.currentstage === this.selectedCurrentStage)
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_to_name: cus.assigned_to_name,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    this.groupProjectsByVersion(this.matchedCustomerData);
    this.updateTableRows();
    this.selectedCurrentStage = eve.target.value;
    this.applyAllFilters();
    this.updateCardCounts();
  }



  applyAllFilters() {
    this.matchedCustomerData = this.allCustomerData.filter((cus:any) => {
      const matchProject = this.selectedProjectName ? cus.projectName === this.selectedProjectName : true;
      const matchCustomer = this.selectedCustomerName ? cus.customer_name === this.selectedCustomerName : true;
      const matchEngineer = this.selectedEngineer ? Number(cus.assigned_to_id) === Number(this.selectedEngineer) : true;
      const matchStage = this.selectedCurrentStage ? cus.currentstage === this.selectedCurrentStage : true;

      // Expected Completion Date Range
      const matchExpectedFrom = this.fromExpectedCompletionDate
        ? new Date(cus.expectedCompletionDate) >= new Date(this.fromExpectedCompletionDate)
        : true;

      const matchExpectedTo = this.toExpectedCompletionDate
        ? new Date(cus.expectedCompletionDate) <= new Date(this.toExpectedCompletionDate)
        : true;


      const matchRfqFrom = this.fromRfqDate
        ? new Date(cus.rfqDate) >= new Date(this.fromRfqDate)
        : true;

      const matchRfqTo = this.toRfqDate
        ? new Date(cus.rfqDate) <= new Date(this.toRfqDate)
        : true;


      return matchProject && matchCustomer && matchEngineer && matchStage &&
        matchExpectedFrom && matchExpectedTo && matchRfqFrom && matchRfqTo;
    }).map((cus:any) => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_to_name: cus.assigned_to_name,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      version_id: cus.version_id,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));

    this.groupProjectsByVersion(this.matchedCustomerData);
    this.updateTableRows();
  }


  openModalECD() {
    this.showModalECD = true;
  }

  // Close ECD Modal
  closeModalECD() {
    this.showModalECD = false;
  }
  resetDates() {
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
  }

  // Open RFQ Modal
  openModalRFQ() {
    this.showModalRFQ = true;
  }

  // Close RFQ Modal
  closeModalRFQ() {
    this.showModalRFQ = false;
  }
  resetRfqDates() {
    this.fromRfqDate = null;
    this.toRfqDate = null;
  }

  onSelectCompletionDate() {

    this.selectedRfqDate = '';
    this.matchedCustomerData = this.allCustomerData.filter((cus:any) => {
      const expectedCompletionDate = new Date(cus.expectedCompletionDate);
      const fromDate = new Date(this.fromExpectedCompletionDate);
      const toDate = new Date(this.toExpectedCompletionDate);
      console.log('Selected from: ', this.fromExpectedCompletionDate, ' to: ', this.toExpectedCompletionDate);

      // Check if the customer's expectedCompletionDate is within the selected range
      return expectedCompletionDate >= fromDate && expectedCompletionDate <= toDate && cus.status === 'Open';
    }).map((cus:any) => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      version_id: cus.version_id,
      upload_status: cus.upload_status,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));
    this.updateTableRows();
    this.applyAllFilters();
    this.updateCardCounts();
  }


  onDateRangeChange() {

    this.selectedExpetedCompletionDate = '';

    console.log('Selected From RFQ Date:', this.fromRfqDate);
    console.log('Selected To RFQ Date:', this.toRfqDate);

    this.matchedCustomerData = this.allCustomerData.filter((cus:any) => {
      const rfqDate = new Date(cus.rfqDate);  // Customer RFQ date
      const fromDate = new Date(this.fromRfqDate); // Selected "From" date
      const toDate = new Date(this.toRfqDate);  // Selected "To" date

      // Check if the customer's RFQ date is within the range
      return rfqDate >= fromDate && rfqDate <= toDate && cus.status === 'Open';
    }).map((cus:any) => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      version_id: cus.version_id,
      upload_status: cus.upload_status,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));
    console.log('Date range changed:', this.fromRfqDate, this.toRfqDate);
    this.updateTableRows();

    this.applyAllFilters();
    this.updateCardCounts();
  }
  onSelectMonthRfq() {
    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => cus.customerName === this.selectedCustomerName)
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        projectName: cus.projectName,
        customerName: cus.customerName,
        rfqDate: cus.rfqDate,
        assignedTo: cus.assignedTo,
        assignedDate: cus.assignedDate,
        expetedCompletionDate: cus.expetedCompletionDate,
        targetLeadTime: cus.targetLeadTime,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        upload_status: cus.upload_status,
        currentStage: cus.currentStage,
        activeStatus: cus.activeStatus,
      }));
  }

  activeTab: number = 1; // Track the active tab

  // Sample data for each table
  tableData1 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' },
    { column1: 'Row 2, Col 1', column2: 'Row 2, Col 2', column3: 'Row 2, Col 3' }
  ];
  tableData2 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData3 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData4 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];

  // Method to set the active tab
  setActiveTab(tabNumber: number): void {
    this.activeTab = tabNumber;
  }

  back() {

  }

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCustomerModel(customerModal) {

    this.modalRef = this.modalService.open(customerModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  resetFields() {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.editProjectRow(null);
    this.getAllProjectData();
  }
  previousStage: string | null = null;

 
  openProjectModel(projectModal, customer, projectId) {

  // Store previous project stage (needed for stage-change logic)
  this.previousStage = customer?.currentstage || null;

  if (customer) {
    this.selectedCustomerId = customer.customer_id;
    this.selectedmatchedCustomerData = customer;
    this.selectedProjectId = customer.project_id;
  }

  this.showAddCustomerButton = false;

  this.modalRef = this.modalService.open(projectModal, { 
    ariaLabelledBy: 'modal-basic-title', 
    size: 'lg' 
  });

  this.modalRef.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });

  // ====== EDIT MODE ======
  if (customer) {

    this.patchCustomerData(customer);

    this.onQn123 = {
  q1: customer.q1 == true || customer.q1 == 'true' || customer.q1 == 1 || customer.q1 == 'yes',
  q2: customer.q2 == true || customer.q2 == 'true' || customer.q2 == 1 || customer.q2 == 'yes',
  q3: customer.q3 == true || customer.q3 == 'true' || customer.q3 == 1 || customer.q3 == 'yes',
};


    this.dutyValuePercentage = customer.duty_percentage;

 
    this.showQn2 = this.onQn123.q1;
this.showQn3 = this.onQn123.q2;
this.showDutyInput = this.onQn123.q3;


  } else {

    // ====== ADD MODE ======
    this.projectForm.reset();
    this.projectForm.patchValue({
      version_id: 1
    });
    this.projectForm.get('version_id')?.disable();

    // Reset Landing Cost fields
    this.onQn123 = { q1: null, q2: null, q3: null };
    this.dutyValuePercentage = null;

    this.showQn2 = false;
    this.showQn3 = false;
    this.showDutyInput = false;
  }
}

  patchCustomerData(selectedmatchedCustomerData) {

    this.projectForm.patchValue({
      newProjectName: selectedmatchedCustomerData.projectName,
      customerFullName: selectedmatchedCustomerData.customer_name,
      rfqDate: selectedmatchedCustomerData.rfqDate,
      completionDate: selectedmatchedCustomerData.expectedCompletionDate,
      targetLT: selectedmatchedCustomerData.targetLeadTime,
      assignTo: selectedmatchedCustomerData.assigned_to_id,
      currentStage: selectedmatchedCustomerData.currentstage,
      version_id: selectedmatchedCustomerData.version_id

    });
    this.projectForm.get('version_id')?.disable();
  }

  onLandinCost(landinCostModal) {
    this.modalRef = this.modalService.open(landinCostModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });

    this.modalRef.result.then((result) => {

      console.log('Received from modal:', result);
      this.closeResult = `Closed with: ${result}`;



    }, (reason) => {
      console.log('Modal dismissed => ', reason);
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
showAddButton: boolean = false;



  closeModal() {

    if (this.modalRef) {
      this.modalRef.close();
      this.showAddCustomerButton = false;
    } else {
      this.modalService.dismissAll();
      this.showAddCustomerButton = false;
    }
    this.modalService.dismissAll();
  }


  onAddNewCustomer(event?: any): void {
  this.selectedCustomerId = event?.id;
  console.log('selectedCustomerId', this.selectedCustomerId);
  
  // Hide Add button when a customer is selected
  if (this.selectedCustomerId) {
    this.showAddButton = false;
  }
}

  onSelectProjectName(eve?: any): void {
    this.selectedProjectId = eve?.id;
    console.log('selectedProjectId', this.selectedProjectId);

  }

  enterProject(eve: any): void {
    let enteredProject = eve.target.value.trim(); // Trim to avoid leading/trailing spaces
    this.isProjectNameDuplicate = this.allCustomerData.some(
      (project:any) => project.projectName === enteredProject
    );
  }
  onEnterCustomerName(eve: any): void {
    let enteredCustomer = eve.target.value.trim(); // Trim to avoid leading/trailing spaces
    this.isCustomerNameDuplicate = this.allCustomerDetails.some(
      (customer:any) => customer.customerName === enteredCustomer
    );
  }

  save(): void {
     if (this.onQn123.q1 === null) {
    this.notify.info("Please answer Landing Cost question (Q1).");
    return;
  }
  if (this.onQn123.q1 === true && this.onQn123.q2 === null) {
    this.notify.info("Please answer Duties question (Q2).");
    return;
  }
  if (this.onQn123.q2 === true && this.onQn123.q3 === null) {
    this.notify.info("Please answer Duty Value question (Q3).");
    return;
  }
  if (this.onQn123.q3 === true && (!this.dutyValuePercentage || this.dutyValuePercentage <= 0)) {
    this.notify.info("Please enter a valid Duty Value Percentage.");
    return;
  }
    if (!this.selectedProjectId) {
      let enteredProject:any = this.projectForm.value.newProjectName;
      if (this.isProjectNameDuplicate) {
        return; // Prevent saving if duplicate
      }

      // If there's no selected project ID, check for duplicate project name

      if (this.allCustomerData.some((project:any) => project.projectName === enteredProject)) {
        this.notify.info('Project already available, choose a different Project Name.');
        return; // Prevent saving if duplicate project name is found
      }
    }

    // Prevent duplicate API calls
    if (this.isSaving) {
      return;
    }

    // Set a flag to indicate that the save process is in progress
    this.isSaving = true;
    let payload: any;

    if (this.projectForm.valid) {
      // Insert logic
      if (!this.selectedProjectId) {
        payload = {
          action: "INSERT",
          project_id: 0,
          version_id: 1,
          projectName: this.projectForm.get('newProjectName')?.value,
          // projectNo: this.projectForm.get('projectNo')?.value,
          // description: this.projectForm.get('description')?.value,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: this.userId,
          created_date: this.currentDate,
          assigned_to_id: Number(this.projectForm.get('assignTo')?.value),
          assigned_date: this.assignDate,
          customer_id: Number(this.selectedCustomerId),
          ageing: 0,
          progress: "0%",
          status: "Open",
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: ""
        };
        this.projectForm.get('version_id')?.disable();
      }

      // Update logic (if selectedProjectId exists)
      if (this.selectedProjectId) {
        payload = {
          action: "UPDATE",
          project_id: this.selectedProjectId,
          version_id: this.selectedmatchedCustomerData.version_id,
          projectName: this.projectForm.get('newProjectName')?.value,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: this.userId,
          created_date: this.currentDate,
          assigned_to_id: Number(this.projectForm.get('assignTo')?.value),
          assigned_date: this.selectedmatchedCustomerData.assigned_date,
          customer_id: Number(this.selectedCustomerId),
          ageing: this.selectedmatchedCustomerData.ageing,
          progress: this.selectedmatchedCustomerData.progress,
          status: this.selectedmatchedCustomerData.status,
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: this.selectedmatchedCustomerData.activestatus
        };
        this.projectForm.get('version_id')?.disable();
      }
    
    
if (this.previousStage === 'Costing' && 
    this.projectForm.get('currentStage')?.value === 'Procurement') {

  payload.q1 = this.selectedmatchedCustomerData.q1;
  payload.q2 = this.selectedmatchedCustomerData.q2;
  payload.q3 = this.selectedmatchedCustomerData.q3;
  payload.duty_percentage = this.selectedmatchedCustomerData.duty_percentage;
}
else {
  // Use current answers
  payload.q1 = this.onQn123.q1 === true;
  payload.q2 = this.onQn123.q2 === true;
  payload.q3 = this.onQn123.q3 === true;
  payload.duty_percentage = this.onQn123.q3 === true ? this.dutyValuePercentage || 0 : 0;
}




      console.log('Final Payload:', payload);
      console.log('payload', payload);

      // API call to save data
      this.masterService.manage_projects(payload).pipe(
        catchError((error) => {
          console.error('Error saving data:', error);
          this.notify.danger('An error occurred while saving the project data. Please try again.');
          return of(null); // Return a fallback observable
        })
      ).subscribe({
        next: (response) => {
          if (response) {
            console.log('Project saved successfully:', response);
            this.notify.success('Project saved successfully.');
            this.projectForm.reset();
            this.closeModal();
            this.getAllProjectData();
          }
        },
        error: (error) => {
          console.error('Unexpected error:', error);
        },
        complete: () => {
          this.isSaving = false;
          this.closeModal();
          this.projectForm.reset();
        }
      });
    } else {
      this.notify.info('Please fill in all required fields.');
      console.log('Form is invalid');
      this.projectForm.reset();
      this.isSaving = false;
    }
  }



  getThisMonthProjects() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    this.thisMonthProjects = this.groupedProjectData.filter(group => {
      const rfqDate = new Date(group.rfqDate);
      return rfqDate.getMonth() === currentMonth && rfqDate.getFullYear() === currentYear;
    });

    console.log("This Month Projects:", this.thisMonthProjects);
  }


  getAllProjectData() {
    this.isRefresh = true;
    this.allCustomerData = [];
    this.matchedCustomerData = [];
    this.groupedProjectData = [];

    const payloadData = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: this.userId
    };

    this.masterService.manage_projects(payloadData).subscribe(
      (result: any) => {
        const status = result?.status;

        if (result && status === 'success') {
          setTimeout(() => {
            this.isRefresh = false;

            const sortedData = result.data.sort((a, b) => {

              if (a.created_date && b.created_date) {
                return new Date(b.created_date).getTime() - new Date(a.created_date).getTime();
              }
              return b.project_id - a.project_id;
            });

            this.allCustomerData = sortedData;
            this.matchedCustomerData = sortedData;

            this.projectNameDetails = Array.from(
              new Set(this.allCustomerData
                .filter((item:any) => item.projectName)
                .map((item:any) => item.projectName.trim()))
            );

            // this.allCustomerData = result.data;
            // this.matchedCustomerData = result.data; // Keep for reference

            this.groupProjectsByVersion(result.data);

            const map = new Map();

            this.allCustomerData.forEach((item:any) => {


              const key = `${item.project_id}`;
              if (!map.has(key)) {
                map.set(key, {
                  ...item,
                  versions: [item.version_id],
                  versionDetails: [item],
                  selectedVersionData: item
                });
              } else {
                const existing = map.get(key);
                existing.versions.push(item.version_id);
                existing.versionDetails.push(item);



                existing.versionDetails.sort((a, b) => b.version_id - a.version_id);

                // Update versions array to match sorted order
                existing.versions = existing.versionDetails.map(v => v.version_id);


                existing.selectedVersionData = existing.versionDetails[0];
              }
            });


            this.groupedProjectData = Array.from(map.values());
            console.log("Grouped Data:", this.groupedProjectData);
            this.originalGroupedData = structuredClone(this.groupedProjectData);

            this.getThisMonthProjects();

            this.openStatusCount = this.groupedProjectData.filter(
              group => group.status === 'Open' || group.status === 'In Progress'
            ).length;


            const today = new Date(); today.setHours(0, 0, 0, 0);

            this.overdueCount = this.groupedProjectData.filter(group => {
              const expectedDate = new Date(group.selectedVersionData?.expectedCompletionDate);
              expectedDate.setHours(0, 0, 0, 0);
              return expectedDate < today && group.selectedVersionData?.status === 'Open';
            }).length;



            this.updateTableRows();


          }, 1000);
        } else {
          console.error('Error: Unable to retrieve project data');
          this.notify.danger('Error: Unable to retrieve project data. Please try again.');
          this.isRefresh = false;
        }
      },
      (error) => {
        console.error('API Error:', error);
        this.isRefresh = false;
        if (error.status === 500) {
          this.notify.danger('Server error: 500 Internal Server Error. Please try again later.');
        } else if (error.status === 0) {
          this.notify.danger('Network error: Unable to reach the server.');
        } else {
          this.notify.danger(`Error: ${error.message || 'Something went wrong!'}`);
        }
      }
    );
  }
  calculateProgress(data: any[]): string {
    const totalRows = data.length;
    if (totalRows === 0) return '0';

    const validSupplierCount = data.filter(
      item => item.supplier && item.supplier !== 'N/A'
    ).length;

    const progress = (validSupplierCount / totalRows) * 100;
    return progress.toFixed(2);
  }
  groupProjectsByVersion(data: any[]) {
    const map = new Map();
    const sortedData = data.sort((a, b) => {
      const dateA = new Date(a.created_date).getTime();
      const dateB = new Date(b.created_date).getTime();
      return dateB - dateA;
    });

    sortedData.forEach(item => {
      const key = `${item.projectName}_${item.rfqDate}_${item.assigned_date}_${item.expectedCompletionDate}`;

      if (!map.has(key)) {
        map.set(key, {
          ...item,
          versions: [item.version_id],
          versionDetails: [item],
          selectedVersionData: item
        });
      } else {
        const existing = map.get(key);
        existing.versions.push(item.version_id);
        existing.versionDetails.push(item);
      }
    });


    this.groupedProjectData = Array.from(map.values());
  }

  onVersionChange(event: any, group: any) {
    const selectedVersionId = Number(event.target.value);
    const selected = group.versionDetails.find(v => v.version_id === selectedVersionId);

    if (selected) {
      group.selectedVersionData = selected;
    }
  }

  saveCustomer() {

    if (this.customerForm.invalid || this.isProjectNameDuplicate) {
      // if (this.isProjectNameDuplicate) {
      return; // Prevent saving if duplicate
      // }
    } else {
      // Prevent duplicate API calls
      if (this.isSaving) {
        return;
      }

      // Set a flag to indicate that the save process is in progress
      this.isSaving = true;

      if (this.customerForm.valid) {
       
const payload = {
  customerName: this.customerForm.get('_customerFullName')?.value,
  city: this.customerForm.get('city')?.value.trim(),
  state: this.customerForm.get('state')?.value.trim(),
  country: this.customerForm.get('country')?.value.trim(),
  gstNumber: this.customerForm.get('gstNumber')?.value.trim(),
};

        console.log('payload', payload);

        // API call to save data
        this.masterService.create_customers(payload).pipe(
          catchError((error) => {
            console.error('Error saving data:', error);
            // Handle error by showing a user-friendly message
            // alert('An error occurred while saving the project data. Please try again.');
            this.notify.danger('An error occurred while saving the project data. Please try again.');
            return of(null); // Return a fallback observable
          })
        ).subscribe({
          next: (response) => {
            if (response) {
              console.log('Customer saved successfully:', response);
              // alert('Customer saved successfully.');
              this.notify.success('Customer saved successfully.');
              // Reset the customerForm after success
              this.customerForm.reset();
              this.closeModal();
              this.showAddCustomerButton = false;
            }
          },
          error: (error) => {
            console.error('Unexpected error:', error);
          },
          complete: () => {
            // Reset the saving flag after the process is complete
            this.isSaving = false;
          }
        });
      } else {
        // alert('Please fill in all required fields.');
        this.notify.info('Please fill in all required fields.');
        console.log('Form is invalid');
        // Optionally reset the form if invalid
        this.customerForm.reset();

        // Reset the saving flag
        this.isSaving = false;
      }
      this.modalService.dismissAll();
      this.customerForm.reset();
      this.showAddCustomerButton = false;
    }
    this.getAllcustomers();
  }


  showQn2: boolean = false;
  showQn3: boolean = false;
  
onQn1Change(answer: string) {
  if (answer === 'yes') {
    this.showQn2 = true;
    this.onQn123.q1 = true;
  } else {
    this.showQn2 = false;
    this.showQn3 = false;
    this.onQn123.q1 = false;
    this.onQn123.q2 = null;
    this.onQn123.q3 = null;
    this.dutyValuePercentage = 0;
  }
}

onQn2Change(answer: string) {
  if (answer === 'yes') {
    this.showQn3 = true;
    this.onQn123.q2 = true;
  } else {
    this.showQn3 = false;
    this.onQn123.q2 = false;
    this.onQn123.q3 = null;
    this.dutyValuePercentage = 0;
  }
}

onQn3Change(value: string) {
  if (value === 'export') {
    this.showDutyInput = true;
    this.onQn123.q3 = true;
  } else {
    this.showDutyInput = false;
    this.onQn123.q3 = false;
    this.dutyValuePercentage = 0;
  }
}








  
  saveLandingCost(modal?: any) {
  const payload: any = {};

  if (this.onQn123.q1 === true) {
    payload.landingcost = true;

    if (this.onQn123.q2 === true) {
      payload.dutiesofcalclandingcost = true;

      if (this.onQn123.q3 !== null) {
        payload.dutyvalue = this.onQn123.q3;

        if (this.onQn123.q3 === true && this.dutyValuePercentage !== null) {
          payload.dutyvaluepercentage = this.dutyValuePercentage;
        }
      }
    } else {
      payload.dutiesofcalclandingcost = false;
    }

  } else {
    payload.landingcost = false;
  }

  console.log("Final Payload:", payload);

  if (modal) {
    modal.close(payload);
  } else {
    this.modalService.dismissAll();
  }
}

  // closeLandingCost(){

  // }
  closeLandingCost(modal?: any) {
    this.resetQuestions();
    if (modal) {
      modal.close();  // Close the popup
    }
  }

  resetQuestions() {
    this.showQn2 = false;
    this.showQn3 = false;

  }
  getProgressBarColor(progress: number): string {
    if (progress < 50) {
      return 'warn'; // Red for less than 50%
    } else if (progress >= 50 && progress < 100) {
      return 'accent'; // Yellow for 50% to 99%
    }
    return 'primary'; // Blue for 100%
  }

  editProjectRow(customer: any): void {

    if (customer) {
      this.selectedmatchedCustomerData = customer;
      this.editingRowId = Number(customer.project_id);
    }
  }

  isRowEditing(projectId: number): boolean {
    return this.editingRowId === projectId;
  }


  onChangeAssignTo(event: any, customer: any): void {
    const engineerId = Number(event.target.value);

    // Find the selected engineer
    const selectedEngineer:any = this.engineersData.find((user:any) => user.engineer_id === engineerId);

    if (selectedEngineer) {
      console.log('Selected Engineer Name:', selectedEngineer.engineer_name);

      // Update all rows in matchedCustomerData with the same project_id
      this.matchedCustomerData.forEach(row => {
        if (row.project_id === customer.project_id) {
          // Update the engineer name and assigned ID
          row.engineer_name = selectedEngineer.engineer_name;
          row.assigned_to_id = engineerId;
          row.currentstage = customer.currentstage;
          // this.changedstage = customer.currentstage;

          // Optionally, set a default currentstage if needed
          if (!row.currentstage || row.currentstage.trim() === '') {
            row.currentstage = ''; // Example placeholder
            this.notify.info('Please select stage');
          }
        }
      });

      // Notify the user to select the stage
    }
  }


  onChangeStage(eve: any) {

    let changedtage = eve.target.value
    this.changedstage = changedtage
    console.log('val', changedtage);

  }

  onRowSelect(customer: any) {
    let role:any = sessionStorage.getItem('role');

    const customerIndex = this.matchedCustomerData.findIndex(c => c.project_id === customer?.selectedVersionData?.project_id);
    if (customerIndex !== -1) {
      this.matchedCustomerData[customerIndex].version_id = Number(customer?.selectedVersionData?.version_id);
      console.log(this.matchedCustomerData[customerIndex].version_id);
      this.selectedVersionId = Number(customer?.selectedVersionData?.version_id);
      this.selectedProjectId = Number(customer?.selectedVersionData?.project_id);
      this.selectedProjectName = String(customer?.selectedVersionData?.projectName);
      sessionStorage.setItem('project_id', this.selectedProjectId);
      sessionStorage.setItem('version_id', String(this.selectedVersionId));
      sessionStorage.setItem('projectName', String(this.selectedProjectName));
      this.menuService.setRole(role);
      if (this.selectedVersionId) {
        sessionStorage.setItem('dashboard_selected_data', JSON.stringify(customer));
        this.router.navigate(['/project-view'], {
        state: { customerInfo: customer, 
            startIndex:this.paginatestartIndex,
            endIndex:this.paginateendIndex,
            currentPage:this.currentPage,
            rowsPerPage:this.rowsPerPage, 
            matchedData: this.matchedCustomerData }

        });;
      } else {
        this.notify.info('Please select version_id.')
      }
    }
  }

}

